import { FC, HoverProps } from "./typings";
import styles from "./styles-hover.module.scss";
import { useEffect, useRef, useState } from "react";
import DotsIcon from "assets/icons/three-dots.svg?react";
import Dropdown from "./Dropdown";
import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

const Hover: FC<HoverProps> = ({
  scrollWrapper,
  showOptions,
  refWrapper,
  options,
  rightSide = false,
  selectedElements,
  setSelectedElements,
  thread = false,
  size,
}) => {
  const { t } = useTranslation();
  const [x, setX] = useState(0);
  const [y, setY] = useState(0);
  const [showDropdown, setShowDropdown] = useState(false);
  const containerRef = useRef(null);
  const animationFrameRef = useRef<number | null>(null);

  const handlePosition = () => {
    const position = refWrapper?.current?.getBoundingClientRect?.();

    if (!position) return;

    if (thread && containerRef?.current) {
      setX(position.x);
      setY(position.y);
      return;
    }

    if (rightSide && containerRef?.current) {
      const sizeOf = containerRef.current.getBoundingClientRect();
      const newX = position.right - sizeOf.width;
      const newY = 27;
      setX(newX);
      setY(newY);
      return;
    }

    const newX = position.x + position.width / 2;
    let newY = position.y - 14;

    if (newY <= 80) {
      newY = 80;
    }

    setX(newX);
    setY(newY);
    return;
  };

  const animatePosition = () => {
    handlePosition();
    animationFrameRef.current = requestAnimationFrame(animatePosition);
  };

  useEffect(() => {
    if (!showOptions) return;

    animationFrameRef.current = requestAnimationFrame(animatePosition);

    return () => {
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
    };
  }, [showOptions]);

  const windowHeight = window.innerHeight - 48;

  if (y > windowHeight) {
    return <></>;
  }

  return (
    <div
      style={{
        left: !rightSide ? `${x}px` : "initial",
        top: !rightSide ? `${y - 7}px` : "initial",
        display: `${
          !showOptions || (!rightSide && y <= 100) ? "none" : "flex"
        }`,
      }}
      ref={containerRef}
      className={`${styles.options} ${!showOptions && styles.hide} ${
        rightSide && styles.rightSide
      } ${size === "small" && styles.small}`}
    >
      {options
        .filter((option) => !option.additional && option.isEnabled)
        .map((option, index) => (
          <option.Icon
            title={option.name}
            onClick={option.callback}
            className={styles.icon}
            key={index}
          />
        ))}

      {!!options.find((option) => option.additional) && (
        <Tooltip title={t("common.showMore")}>
          <div>
            <DotsIcon
              onClick={() => {
                setShowDropdown(!showDropdown);
              }}
              className={styles.icon}
            />
          </div>
        </Tooltip>
      )}
      {showDropdown && (
        <Dropdown
          toggle={() => setShowDropdown(false)}
          rightSide={rightSide}
          scrollWrapper={scrollWrapper}
          options={options.filter(
            (option) => option.additional && option.isEnabled
          )}
          refWrapper={containerRef}
          showOptions={showOptions}
          selectedElements={selectedElements}
          setSelectedElements={setSelectedElements}
        />
      )}
    </div>
  );
};

export default Hover;
